import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Introduction to .NET & C#",
    points: [
      "What is .NET framework and .NET Core",
      "Introduction to C# programming language",
      "Setting up development environment (Visual Studio)",
      "Basic syntax, variables, and data types",
    ],
  },
  {
    title: "C# Fundamentals",
    points: [
      "Control statements and loops",
      "Object-Oriented Programming concepts",
      "Classes, objects, inheritance, polymorphism",
      "Exception handling in C#",
    ],
  },
  {
    title: "HTML, CSS & JavaScript Basics",
    points: [
      "Building web pages using HTML",
      "Styling with CSS and responsive design",
      "JavaScript fundamentals for interactivity",
      "DOM manipulation basics",
    ],
  },
  {
    title: "ASP.NET Core Development",
    points: [
      "Introduction to ASP.NET Core MVC",
      "Controllers, Views, and Models",
      "Routing and middleware concepts",
      "Building web applications using MVC pattern",
    ],
  },
  {
    title: "Web API Development",
    points: [
      "Introduction to REST APIs",
      "Creating Web APIs using ASP.NET Core",
      "CRUD operations with API endpoints",
      "Testing APIs using Postman",
    ],
  },
  {
    title: "Entity Framework Core",
    points: [
      "Introduction to ORM and EF Core",
      "Database-first and Code-first approaches",
      "Migrations and database management",
      "LINQ queries and data handling",
    ],
  },
  {
    title: "Frontend Integration",
    points: [
      "Connecting frontend with .NET backend",
      "Consuming APIs in frontend applications",
      "Basic React/Angular integration concepts",
      "Handling JSON data and responses",
    ],
  },
  {
    title: "Authentication & Security",
    points: [
      "User authentication and authorization",
      "JWT token-based authentication",
      "Role-based access control",
      "Security best practices in .NET",
    ],
  },
  {
    title: "Deployment & Real-Time Projects",
    points: [
      "Publishing applications to IIS and cloud",
      "Hosting .NET applications on Azure",
      "Version control with Git and GitHub",
      "End-to-end real-time project development",
    ],
  },
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive DotNet syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
